import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { TipoReporte } from "@shared/enums/tipoReporte";

@Component({
  selector: 'app-control-credito-index',
  templateUrl: './control-credito-index.component.html',
  styleUrls: ['./control-credito-index.component.scss']
})
export class ControlCreditoIndexComponent {

  constructor(private authService: AuthService) {}
  TipoReporte = TipoReporte;
  TipoUsuario = TipoUsuario

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

  
}
